<script>
    import R, {LOADER} from "../lib/requests";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import A from "../lib/Router/A.svelte";
    import HotelSelect from "../components/controls/HotelSelect.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import HotelSelectModal from "../hotels/HotelSelectModal.svelte";

    export let department = null;

    let selectedHotels = null;

    const save = (hotelIds) => {
        const onSuccess = result => {
            if (result.length < department.hotels.length) {
                Notifier.showMessage("Hotel removed from department");
            } else {
                Notifier.showMessage("Hotel related to department");
            }
            department.hotels = result;
        }

        const onFailure = err => {
            Alert.warning("Department", err.message);
        };

        R.handle(R.department.editHotels, {
            id: department.id,
            hotels: hotelIds
        }, onSuccess, onFailure, LOADER.POPUP);
    }

    const onAdd = ({detail: hotelObj}) => {
        let ids = [hotelObj.id, ...department.hotels.map(item => (item.id))];
        save(ids);
    }

    const onRemove = (hotelObj) => {
        Alert.confirm("Remove hotel", `This will remove hotel "${hotelObj.name}" from department.\nAre you sure?`, () => removeHotel(hotelObj.id));
    }

    const removeHotel = (id) => {
        let ids = department.hotels.map(item => (item.id)).filter(x => x != id);
        save(ids);
    }

    const openModal = () => {
        selectedHotels = department.hotels.map(item => (item.id))
    }

    const closeModal = (selected) => {
        if (selected) {
            save(selected);
        }
        selectedHotels = null;
    }
</script>

<div class="panel panel-default mb-5">
    <div class="panel-heading py-2">
        Hotels
    </div>
    {#if department.id > 0}
        <div class="panel-body p-2 border-bottom">
            <div class="tools-box">
                <HotelSelect excludeFromSelection="{ department.hotels }" on:select="{ onAdd }"
                             placeholder="add existing hotel"/>
                <button class="btn btn-default btn-flex line-height-1 ms-1" title="select from list" on:click="{ openModal }">
                    <AppIcon icon="list" size="16" strokeWidth="2"/>
                </button>
            </div>
        </div>
        {#if department.hotels.length}
            <table class="table table-list">
                <tbody>
                {#each department.hotels as item}
                    <tr class="row-hover">
                        <td>
                            <A href="/app/hotel/{ item.id }" class="text-dark is-link">
                                <span class:not-active={department?.account?.is_active < 1}>
                                    { item.name }
                                </span>
                            </A>
                        </td>
                        <td class="button-column pointer" title="remove hotel from department"
                            on:click="{ () => onRemove(item) }">
                            <AppIcon icon="x" size="16"/>
                        </td>
                    </tr>
                {/each}
                </tbody>
            </table>
        {/if}
    {:else}
        <div class="panel-body panel-pad">
            Save new department in order to add hotels
        </div>
    {/if}
</div>
{#if selectedHotels != null}
    <HotelSelectModal selected={ selectedHotels } callbackHandler="{ closeModal }"/>
{/if}